import { useGetEmissorContractSummaryQuery } from '../services/contractSummaryApi';
const EMPTY_PRODUCTS = [];
export function useEmissorContractSummary({ contractId, skip = false, }) {
    const shouldSkip = skip || !contractId;
    const { data, isLoading, isError, isFetching, refetch } = useGetEmissorContractSummaryQuery({ contractId: contractId ?? '' }, { skip: shouldSkip });
    return {
        summary: data ?? null,
        products: data?.products ?? EMPTY_PRODUCTS,
        renewalDate: data?.renewalDate ?? null,
        status: data?.status ?? null,
        legalName: data?.legalName ?? null,
        isLoading,
        isError,
        isFetching,
        refetch,
    };
}
